import { controls, grouped } from "../controls";
const feedbacks = {
  label: "Feedbacks",
  pageLabel: "Feedbacks", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  pageType: "history",
  filter: [
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Feedback", width: "col-sm-12", style: { textAlign: "left" } }),
    ...controls.simpleeditor({ tab: "general", name: "feedback_display" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Feedbacks",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Feedback", accessor: "feedback_display", },
    ]
  }
};
export default feedbacks;